<div
  class="play-button-container" [ngClass]="{'play':isPlayable && !inProgress}"
  (mousedown)="onClick()"
>
  <circle-progress
    [space]="5"
    [percent]="progress"
    [radius]="radius"
    [backgroundStroke]="'white'"
    [outerStrokeWidth]="8"
    [outerStrokeColor]="outerStrokeColor"
    [outerStrokeGradientStopColor]="outerStrokeGradientStopColor"
    [innerStrokeWidth]="1"
    [innerStrokeColor]="'#0'"
    [animation]="false"
    [animateTitle]="false"
    [animationDuration]="0"
    [imageSrc]="(imageUrl | async)??''"
    [imageHeight]="imageHeight"
    [imageWidth]="imageWidth"
    [showImage]="true"
    [showBackground]="false"
    [showTitle]="false"
  ></circle-progress>
</div>
